import { configPromise } from 'config';
import React, { PureComponent } from 'react';

export const withAppLogo = (Component) => {

  class WithAppLogo extends PureComponent {

    state = {
      logoUrl: null
    };

    async componentWillMount() {
      const config = await configPromise;
      const logoUrl = config.logoConfig.getAppLogo(config.defaultModule);
      this.setState({ logoUrl, moduleCode: config.defaultModule });
    }

    render() {
      return (
        <Component
          {...this.props}
          logoUrl={this.state.logoUrl}
          moduleCode={this.state.moduleCode}
        />
      );
    }

  }

  return WithAppLogo;

};
